import type { Boutique } from '../hooks/useBoutiques';

/** Resolve the image shown in the homepage featured hero for a boutique. */
export function getFeaturedHeroImage(boutique: Pick<Boutique, 'featuredImage' | 'coverImage' | 'logo'>): string {
  return boutique.featuredImage || boutique.coverImage || boutique.logo || '';
}

/** Sort featured boutiques for deterministic carousel order. */
export function sortFeaturedBoutiques<T extends Pick<Boutique, 'featuredOrder' | 'name'>>(boutiques: T[]): T[] {
  return [...boutiques].sort((a, b) => {
    const aOrder = typeof a.featuredOrder === 'number' ? a.featuredOrder : Number.MAX_SAFE_INTEGER;
    const bOrder = typeof b.featuredOrder === 'number' ? b.featuredOrder : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) return aOrder - bOrder;
    return (a.name || '').localeCompare(b.name || '');
  });
}

/** Advance carousel index with wrap-around. */
export function nextCarouselIndex(current: number, total: number, delta: number): number {
  if (total <= 0) return 0;
  return ((current + delta) % total + total) % total;
}

export type CarouselKeyAction = 'prev' | 'next' | 'first' | 'last' | 'activate' | null;

/** Map keyboard input to carousel navigation actions. */
export function handleCarouselKeyDown(
  key: string,
  _activeIndex: number,
  total: number,
): CarouselKeyAction {
  if (total <= 0) return null;

  switch (key) {
    case 'ArrowLeft':
      return 'prev';
    case 'ArrowRight':
      return 'next';
    case 'Home':
      return 'first';
    case 'End':
      return 'last';
    case 'Enter':
    case ' ':
      return 'activate';
    default:
      return null;
  }
}
